import axios, { AxiosResponse } from 'axios';
import { CustomerProducts } from 'views/feed-management/features/customers/types/customer-products.type';
import { UpdateCustomerDisconnectFeedsInput } from 'views/feed-management/features/customers/types/update-customer-disconnect-feeds-input.type';
import { UpdateCustomerLinkFeedsInput } from 'views/feed-management/features/customers/types/update-customer-link-feeds-input.type';
import { UpdateCustomerManualFeedsLinkInput } from 'views/feed-management/features/customers/types/update-customer-manual-feeds-link-input.type';
import { UpdateCustomerProductsInput } from 'views/feed-management/features/customers/types/update-customer-products-input.type';

// PUT
// /ewosapi/v1/bestmix/manage/companies
export const putCustomerLinkProducts = async (request: UpdateCustomerLinkFeedsInput): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v1/bestmix/manage/companies`, request);
};

// PUT
// /ewosapi/v1/feeds/manual/company/${globalCompanyId}/map-feeds
export const putCustomerLinkFeeds = async (
  globalCompanyId: string,
  request: UpdateCustomerManualFeedsLinkInput
): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v1/feeds/manual/company/${globalCompanyId}/map-feeds`, request);
};

// PUT
// /ewosapi/v1/bestmix/company/{globalCompanyId}/product
// Set products for company with details.
export const putFeedManagementCustomerProducts = async (
  globalCompanyId: string,
  request: UpdateCustomerProductsInput[]
): Promise<CustomerProducts> => {
  const res = await axios.put<CustomerProducts>(`/ewosapi/v1/bestmix/company/${globalCompanyId}/product`, request);
  return res.data;
};

// PUT
// /ewosapi/v1/bestmix/manage/:globalCompanyId/remove-products
// Disconnect products from client.
export const putDisconnectCustomerFeeds = async (
  globalCompanyId: string,
  request: UpdateCustomerDisconnectFeedsInput
): Promise<AxiosResponse> => {
  return await axios.put<AxiosResponse>(`/ewosapi/v1/bestmix/manage/${globalCompanyId}/remove-products`, request);
};
